import { initCommentsExpandedAdverts } from '../../insert/comments-expanded-advert';
import { init as initFootballRightAds } from '../../insert/fixures';
import { init as initHighMerch } from '../../insert/high-merch';
import { init as initMobileSticky } from '../../insert/mobile-sticky';
import { init as initLiveblogAdverts } from '../../insert/spacefinder/liveblog-adverts';
import { reportError } from '../../lib/error/report-error';
import { initArticleBodyAdverts } from './article-body-adverts';
const dynamicAdSlotModules = [
    ['cm-mobileSticky', initMobileSticky],
    ['cm-highMerch', initHighMerch],
    ['cm-articleBodyAdverts', initArticleBodyAdverts],
    ['cm-liveblogAdverts', initLiveblogAdverts],
    ['cm-commentsExpandedAdverts', initCommentsExpandedAdverts],
    ['cm-footballRight', initFootballRightAds],
];
export const initDynamicAdSlots = async () => {
    return Promise.all(dynamicAdSlotModules.map(async ([name, init]) => {
        try {
            await init();
        }
        catch (error) {
            reportError(error, 'commercial', { tag: name });
        }
    }));
};
